import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { TimeSheetReport} from "../../../components/Reports/TimeSheetReport";

export interface ITimeSheetReportSetupPage {}

export const TimeSheetReportPage: FC<ITimeSheetReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Time Sheet Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<TimeSheetReport />}
		/>
	);
};
